export enum TransactionSubType {
	NotSet = 0,
	Standart = 10,
	SocialReservation = 11,
	PromoterReservation = 12,
    Group   = 13,
    Rsvp = 20,
	NoRsvp = 21,
    RsvpPool = 22,
    Refund   = 30,
	Void = 40,
}



// WEBPACK FOOTER //
// ./src/app/models/transaction-sub-type.enum.ts